import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";

const defaultRemarkPlugins = [remarkGfm, remarkMath];
const defaultRehypePlugins = [rehypeKatex];

export default function Markdown({
  children,
  remarkPlugins = [],
  rehypePlugins = [],
  ...props
}) {
  return (
    <ReactMarkdown
      remarkPlugins={[...defaultRemarkPlugins, ...remarkPlugins]}
      rehypePlugins={[...defaultRehypePlugins, ...rehypePlugins]}
      {...props}
    >
      {children}
    </ReactMarkdown>
  );
}
